import { useEffect, useState } from "react";
import { getExchangeRate } from "../../../../callApi/httpservice";
import ManagerExchangeRateTable from "../../ManagerExchangeRateTable";
import Modal from "react-modal";
import { useStores } from "../../../../srores";
import { observer } from "mobx-react-lite";

function ExchangeRateTab() {
  const { adminStore } = useStores();
  const [items, setItems] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>(new Date());
  const take: number = 10;
  const [offset, setOffset] = useState<number>(0);
  const [skip, setSkip] = useState<number>(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemEdit, setItemEdit] = useState<any>(null);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [announceErrModal, setAnnounceErrModal] = useState<boolean>(false);
  const customStyles = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
    },
  };
  const callApiGetExchangeRates = async () => {
    setIsFetching(true);
    setItems(null);
    let start = new Date(startDate);
    let end = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    const result: any = await getExchangeRate({
      take,
      skip,
      sortDesc: true,
      sortBy: "createdAt",
      startAt: Math.floor(new Date(start).getTime() / 1000),
      endAt: Math.floor(new Date(end).getTime() / 1000),
    });
    if (result.status === 200) {
      setItems(result.data[0]);
      let count = result.data[1] as number;
      if (count % take === 0) {
        setPageCount(count / take);
      } else {
        setPageCount(Math.floor(count / take) + 1);
      }
    }
    setIsFetching(false);
  };
  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    setOffset(selectedPage);
    setSkip(selectedPage * take);
  };
  const checkErrExchangeRateTable = async () => {
    let start = new Date(startDate);
    let end = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    const result: any = await getExchangeRate({
      take,
      skip,
      sortDesc: true,
      sortBy: "createdAt",
      startAt: Math.floor(new Date(start).getTime() / 1000),
      endAt: Math.floor(new Date(end).getTime() / 1000),
    });
    if (!result.data[2] && adminStore.shouldAnnounceErrModal) {
      setAnnounceErrModal(true);
      adminStore.updateShouldAnnounceErrModal(false);
    }
  };
  const closeModal = () => {
    setAnnounceErrModal(false);
  };
  useEffect(() => {
    checkErrExchangeRateTable();
  }, [startDate]);
  useEffect(() => {
    callApiGetExchangeRates();
  }, [offset, startDate]);
  return (
    <>
      <div className="bg-white xsm:p-1 xsm:pt-3 md:pt-5 xl:pt-10 md:p-5 xl:p-10 shadow-lg rounded-lg xsm:text-[12px] xs:text-[14px]">
        <ManagerExchangeRateTable
          setStartDate={setStartDate}
          startDate={startDate}
          items={items}
          setItems={setItems}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
          offset={offset}
          setItemEdit={setItemEdit}
          itemEdit={itemEdit}
          isFetching={isFetching}
        />
      </div>
      <Modal
        isOpen={announceErrModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Success modal"
        ariaHideApp={false}
      >
        <div className="flex-col text-center justify-center p-5">
          <div className="font-bold xsm:text-[16px] xs:text-[18px]">
            Notification
          </div>
          <p className="mt-5">API from Techcombank is currently broken.</p>
          <p>Need to fix it manually.</p>
          <div className="flex justify-center mt-5">
            <div
              className="bg-[#EED484] text-[14px] py-2 px-3 w-[80%] rounded-2xl text-center hover:bg-[#dac176] cursor-pointer"
              onClick={closeModal}
            >
              Close
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default observer(ExchangeRateTab);
